import { Controller } from '@hotwired/stimulus'
import { post, destroy } from '@rails/request.js'

// Connects to data-controller="favorite"
export default class extends Controller {
  static values = {
    id: String,
    idFund: String
  }

  connect() {
    this.element.addEventListener('favorite:favorited', () => {
      this.favoriteFund()
    })
    this.element.addEventListener('favorite:delete', () => {
      this.destroyFavorite()
    })
  }
    
  async favoriteFund() {
    let response = await post('/fund/' + this.idFundValue + '/favorite', { responseKind: 'json' }) 
    let data = await response.json
    let status = data.status

    if (status == 1) {
      this.syncFavorite('favorited', data.id)
    } else if (status < 0) {
      alert(data.msg)
    }
  }

  async destroyFavorite() {
    let response = await destroy(
      `/fund/${this.idFundValue}/favorite/${this.idValue}`,
      { responseKind: 'json' })
    let data = await response.json
    let status = data.status

    if (status == 2) {
      this.syncFavorite('deleted')
    } else if (status < 0) {
      alert(data.msg)
    }
  }

  syncFavorite(status, favoriteId) {
    let allFavoriteButtons = document.querySelectorAll(`[data-controller="favorite"][data-favorite-id-fund-value="${this.idFundValue}"]`)
    allFavoriteButtons.forEach(el => { 
      if (status === 'favorited') {
        el.setAttribute('data-favorite-id-value', favoriteId)
        el.dispatchEvent(new CustomEvent('favorite-saved'))
      } else if (status === 'deleted') {
        el.setAttribute('data-favorite-id-value', '')
        el.dispatchEvent(new CustomEvent('favorite-deleted'))
      }
    })
  }
}
